var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isUsePag)?_c('a-pagination',{attrs:{"show-size-changer":"","show-quick-jumper":"","total":_vm.pagination.total,"current":_vm.pagination.current,"page-size":_vm.pagination.pageSize,"page-size-options":_vm.pagination.pageSizeOptions,"show-total":_vm.pagination.showTotal},on:{"showSizeChange":_vm.onShowSizeChange,"change":_vm.onChange}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ba18172","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UsePagination.vue
// module id = null
// module chunks = 